import styled from 'styled-components';
import { Select } from '@material-ui/core';
import media from 'styled-media-query';

import * as Common from '../../Styles';

const Theme = Common.Theme;

export const HomeRootContainer = styled.div`
	margin: 1rem 0rem 1rem 0rem;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
	display: flex;
	flex-direction: column;
	align-self: center;
	width: 95%;
`;

export const TitleContainer = styled.div`
	width: 95%;
	align-self: center;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const Filter = styled.div`
	font-size: 20px;
	font-family: 'Prompt', sans-serif;
	margin: 0rem;
	align-self: center;
	font-weight: 500;
	cursor: pointer;
`;

export const CircularProgressContainer = styled.div`
	display: flex;
	flex: 1;
	min-height: 150px;
	margin: 0 auto;
	justify-content: center;
	overflow: hidden;
`;

export const SummaryCardContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-self: center;
	width: 95%;
	flex-wrap: wrap;
	margin-bottom: 1.5rem;
`;

export const SummaryCardOuter = styled.div`
	display: flex;
	flex-direction: column;
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	border-radius: 4px;
	background-color: ${Theme.white};
	box-shadow: 0 0 12px 0 ${Theme.shadow};
	margin: 0.5rem;
	${media.lessThan('1280px')`
        width: 100%
    `}
`;

export const SummaryCardInner = styled.div`
	display: flex;
	flex-direction: column;
	margin: 1rem 2rem 1rem 2rem;
`;

export const SelectFormControl = styled(Select)`
	width: 7rem;
	font-family: 'Prompt', sans-serif !important;
	font-size: '20px' !important;
	color: black;
	text-transform: capitalize;
`;

export const CircularProgress = styled(Common.CircularProgress)``;

export const PopoverBody = styled(Common.PopoverBody)``;

export const PopoverItem = styled(Common.PopoverItem)``;

export const Popover = styled(Common.Popover)``;

export const PopoverTitle = styled(Common.PopoverTitle)``;

export const Search = styled(Common.Search)``;

export const RootContainer = styled(Common.RootContainer)``;

export const TitleSection = styled(Common.TitleSection)``;

export const TitleRow = styled(Common.TitleRow)``;

export const Title = styled(Common.Title)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const Container = styled(Common.Container)``;

export const DateRangePicker = styled(Common.DateRangePicker)``;

export const LocalizationProvider = styled(Common.LocalizationProvider)``;

export const MenuItem = styled(Common.MenuItem)``;

export const SubTitle = styled(Common.Subtitle)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FilterButton = styled(Common.Button)`
	color: ${Theme.black} !important;
`;

export const StatValue = styled(Common.FlexColumn)`
	min-width: 1rem;
	margin: 0rem 0.25rem;
	color: ${Theme.orange};
	font-family: 'Prompt', sans-serif;
	font-size: 20px;
	font-weight: 500;
	line-height: 2rem;
`;

export const StatText = styled(Common.FlexColumn)`
	margin: 0rem 0.25rem;
	padding-top: 2px;
	color: ${Theme.black};
	font-family: 'Prompt', sans-serif;
	font-size: 14px;
	font-weight: 400;
	line-height: 2rem;
`;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;